import React from 'react';


interface SeparatorProps {
	className?: string;
}

const Separator: React.FunctionComponent<SeparatorProps> = props => {
	return (
		<hr className={`separator ${props.className ? props.className : ''}`}></hr>
	)
}

export default Separator;